import { UserTypesInterface } from "interfaces";
import { get, patch, post, remove } from "services/services.methods";
import { UserTypePaths } from "services/services.paths";

export const GetUserTypes = () => {
  const response = get<UserTypesInterface[]>(UserTypePaths.get);

  return response;
};

export const CreateUserTypes = async (data: any) => {
  const response = post<UserTypesInterface>(UserTypePaths.post, data);
  return response;
};


export const UpdateUserTypes = async (id: number, data: any) => {
  const response = await patch<UserTypesInterface>(
    UserTypePaths.put + `/${id}`, data);

  return response;
};

export const DeleteUserTypes = async (id: number) => {
  const response = await remove<UserTypesInterface[]>(
    UserTypePaths.delete + `/${id}`
  );
  return response;
};
